import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuth } from "firebase/auth";
import { logOut } from "../features/authSlice";

const auth = getAuth();

const getToken = async () => {
  const user = auth.currentUser;
  if (user) {
    return await user.getIdToken(true); // Ensures a fresh token if needed
  }
  return null;
};

const baseQuery = fetchBaseQuery({
  baseUrl: "/api",
  // baseUrl: "http://localhost:8000/api",
  prepareHeaders: async (headers) => {
    const token = await getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    console.error("Unauthorized, attempting token refresh...");
    const token = await getToken();

    if (token) {
      console.log("Token refreshed, retrying request.");
      result = await baseQuery(args, api, extraOptions);
    } else {
      console.error("Token refresh failed, logging out user.");
      api.dispatch(logOut());
    }
  }

  return result;
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const apiCollection = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["CallTasks"],

  endpoints: () => ({}),
  // endpoints: (build) => ({
  //   getAccessLevel: build.query({
  //     query: () => "/facility/accessLevel",
  //   }),
  // }),
});
